module.exports = __webpack_public_path__ + "annualreview2017/static/img/resilience.a34e2ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/people/resilience.jpg
// module id = 770
// module chunks = 0